{
  "length": "{value, number} {unit, select, yd {{value, plural, one {yard} other {yards}}} ft {{value, plural, one {foot} other {feet}}} m {{value, plural, one {metre} other {metres}}} other {}}",
  "length_short": "{value, number} {unit, select, yd {yd} ft {ft} m {m} other {}}",
  "length_range_short": "{lo, number}–{hi, number} {unit, select, yd {yd} ft {ft} m {m} other {}}",
  "speed": "{value, number} {unit, select, mph {mph} kph {km/h} mps {m/s} other {}}",
  "speed_range_short": "{lo}–{hi} {unit, select, mph {mph} kph {km/h} mps {m/s} other {}}",
  "speed_range_words": "{lo} to {hi} {unit, select, mph {miles an hour} kph {kilometres an hour} mps {metres a second} other {}}",
  "temperature": "{value, number}°{unit, select, c {C} f {F} other {}}",
  "green_speed": "{value, number} on the Stimpmeter",
  "length_short_signed": "{value} {unit, select, yd {yd} ft {ft} m {m} other {}}"
}
